export default {
    baseStyle: (props) => ({
        textBlockStyle: {
            fontSize: {base: 'sm', lg: 'md'},
            letterSpacing: '0%',
            fontWeight: 'normal',
            lineHeight: '100%',
            marginBottom: 1
        }
    })
}
